import React, {useState, useCallback, useEffect} from 'react';
import Dropdown from 'react-dropdown';
import {MIX, ALTERNATE, ROUND_ROBIN} from 'constants/instrument-mix-modes.js';

export default function MixModeDropdown(props) {
    const [value, setValue] = useState(undefined);
    const onChange = useCallback((o) => {
        props.instrument.mixMode = o.value;
        setValue(o.value);
    }, [props.instrument]);

    useEffect(() => {
        setValue(props.instrument.mixMode);
    }, []);

    return (
        <div className="interpolation-dropdown-container">
          <Dropdown
            className='interpolation-dropdown'
            controlClassName='interpolation-control-dropdown'
            arrowClassName='interpolation-arrow-dropdown'
            options={OPTIONS}
            onChange={onChange}
            value={getOption(value)}
            placeholder="Mode" />
        </div>
    );
}

function getOption(value) {
    return OPTIONS.find(opt => opt.value === value);
}

const OPTIONS = [
    {value: MIX, label: 'Mix'},
    {value: ALTERNATE, label: 'Alternate'},
    {value: ROUND_ROBIN, label: 'Round Robin'},
];
